import clsx from "clsx"
import toast from "react-hot-toast"
import { ToastContent } from "@/shared/components/common"
import { Tick, Warning } from "@/shared/components/ui/icons"

export class Notice {
  static info(message: string, duration = 3000) {
    toast.custom(
      t => (
        <ToastContent
          onClose={() => toast.dismiss(t.id)}
          style={t.style}
          className={t.visible ? "animateEnter" : "animateLeave"}
          message={message}
          type="info"
        />
      ),
      { duration }
    )
  }

  static success(message: string, duration = 3000) {
    toast.custom(
      t => (
        <ToastContent
          onClose={() => toast.dismiss(t.id)}
          style={t.style}
          icon={<Tick className="!stroke-2 size-4" />}
          className={clsx(
            "bg-gradient-to-r from-[#DEEDE6] via-[#F9FEFD] to-white",
            t.visible ? "animate-toastEnter transition" : "animate-toastLeave transition"
          )}
          message={message}
          type="success"
        />
      ),
      {
        duration
      }
    )
  }

  static warning(message: string, duration = 3000) {
    toast.custom(
      t => (
        <ToastContent
          onClose={() => toast.dismiss(t.id)}
          style={t.style}
          icon={<Warning className="size-[14px] text-white" />}
          className={clsx(
            "bg-gradient-to-r from-[#fff3d3] via-[#fffbf0] to-white",
            t.visible ? "animate-toastEnter transition" : "animate-toastLeave transition"
          )}
          message={message}
          type="warning"
        />
      ),
      {
        duration
      }
    )
  }

  static error(message: string, duration = 3000) {
    toast.custom(
      t => (
        <ToastContent
          onClose={() => toast.dismiss(t.id)}
          style={t.style}
          icon={<p className="text-md text-white">!</p>}
          className={clsx(
            "bg-gradient-to-r from-[#FEF2F6] via-[#FEFCFB] to-white",
            t.visible ? "animate-toastEnter transition" : "animate-toastLeave transition"
          )}
          message={message}
          type="error"
        />
      ),
      {
        duration
      }
    )
  }
}
